module.exports = __webpack_public_path__ + "img/game_over.1df03435.png";